<template>
    <div class="form">
        <h4 class="step-title">
            Are you married?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <yes-no-button-list v-bind:onclick="complete"></yes-no-button-list>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "IsMarried",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(isMarried) {
              this.lead.isMarried = isMarried;
              this.$emit("complete", this.$options.name, isMarried);
          }
        }
    }
</script>
